import { Contact, UsersRound } from "lucide-react";
import type { JSX } from "react";

import { DetailTabs, type DetailTab } from "@crm-src/components/detail-tabs";

/**
 * The two tabs of CRM ▸ **Contacts & Groups** (2026-09-12):
 *
 *   - **Contacts** — the contact directory (`ContactsPage`).
 *   - **Groups** — the contact groups email campaigns are sent to
 *     (`ContactGroupsPage`).
 *
 * The two used to be sibling nav entries ("Contacts" and "Contact Groups");
 * they are one page now, with the active tab in `?tab=` (`ContactsHubPage`).
 * Both tabs sit behind the SAME grant (`crm:contacts` → `contacts:access`),
 * so the strip never has to hide one of them.
 */
export const CONTACTS_HUB_TAB_IDS = ["contacts", "groups"] as const;
export type ContactsHubTabId = (typeof CONTACTS_HUB_TAB_IDS)[number];

export const CONTACTS_HUB_TABS: readonly DetailTab[] = [
  { id: "contacts", label: "Contacts", icon: Contact },
  { id: "groups", label: "Groups", icon: UsersRound },
];

interface ContactsHubTabsProps {
  activeId: ContactsHubTabId;
  onTabChange: (id: ContactsHubTabId) => void;
}

export function ContactsHubTabs({ activeId, onTabChange }: ContactsHubTabsProps): JSX.Element {
  return (
    <DetailTabs
      tabs={[...CONTACTS_HUB_TABS]}
      activeId={activeId}
      onTabChange={(id) => onTabChange(id as ContactsHubTabId)}
      ariaLabel="Contacts & Groups sections"
    />
  );
}
